import { useState, useContext } from "react"
import { Link } from "react-router-dom"
import { UserContext } from "../../../contexts/UserContext"
import "./accountMenu.css"

export function AccountMenu() {
    const [accountMenuDisplay, setAccountMenuDisplay] = useState(false)

    const userDataContext = useContext(UserContext)
    const { user, dispatch } = userDataContext

    async function handleLogout() {
        setAccountMenuDisplay(!accountMenuDisplay)
        localStorage.removeItem("user")
        dispatch({ type: "LOGOUT" })
        window.location = "/"
    }

    return (
        <div
            onClick={() => setAccountMenuDisplay(!accountMenuDisplay)}
            className={
                `account-icon position-relative d-flex justify-content-end 
                ${accountMenuDisplay ? "on" : "off"}`
            }
            style={{ backgroundImage: `url('${user.profilePicture}')`}}>

            <div className="account-menu p-2 rounded-1" onClick={(e) => e.stopPropagation()}>
                <i
                    className="fa-solid fa-x nav-toggle md-off"
                    onClick={() => setAccountMenuDisplay(false)}>
                </i>

                <div className="username text-center">
                    {user && (user.firstName + " " + user.lastName)}
                </div>

                <hr className="my-2" />

                <div className="d-flex align-items-center gap-2">
                    <div className="account-link-icon"></div>
                    <Link to="/account" onClick={() => setAccountMenuDisplay(!accountMenuDisplay)}>
                        Manage My Account
                    </Link>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div className="order-link-icon"></div>
                    <Link to="/account/orders" onClick={() => setAccountMenuDisplay(!accountMenuDisplay)}>
                        My Orders
                    </Link>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div className="cancellations-link-icon"></div>
                    <Link
                        to="/account/cancellations"
                        onClick={() => setAccountMenuDisplay(!accountMenuDisplay)}>
                            My Cancellations
                    </Link>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div className="reviews-link-icon"></div>
                    <Link to="/account" onClick={() => setAccountMenuDisplay(!accountMenuDisplay)}>
                        My Reviews
                    </Link>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <div className="logout-link-icon"></div>
                    <Link onClick={handleLogout}>Logout</Link>
                </div>

            </div>
        </div>
    )
}